import { get, getPaginated, patch, post, remove } from '@/api/base'
import { i18n } from '@/i18n'

const costCentersApi = {
  get: async costCenterUuid => {
    const response = await get({
      path: `cost_centers/${costCenterUuid}`,
    })
    return response.success ? response.data.cost_center : null
  },
  getZones: async (companyUuid, costCenterUuid) => {
    const response = await get({
      path: `cost_centers/zones`,
      params: {
        company_uuid: companyUuid,
        cost_center_uuid: costCenterUuid,
      },
    })
    return response.success ? response.data : null
  },
  getAll: async params => {
    const response = await get({
      path: 'cost_centers',
      params: params,
    })

    return response.success
      ? {
          ...response,
          cost_centers: response.data.cost_centers,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  getPaginated: async params => {
    const response = await getPaginated({ path: 'cost_centers', valuePath: 'cost_centers', params: params })
    return response.success ? response.values : []
  },
  create: async params => {
    const response = await post({
      path: 'cost_centers',
      params,
    })
    return response.success ? response.data.cost_center : null
  },
  update: async (costCenterUuid, params) => {
    const response = await patch({
      path: `cost_centers/${costCenterUuid}`,
      params,
    })
    return response.success ? response.data.cost_center : null
  },
  delete: async costCenterUuid => {
    return await remove({
      path: `cost_centers/${costCenterUuid}`,
      options: { message: i18n.t('costCenters.notifications.deleted') },
    })
  },
  archive: async costCenterUuid => {
    return await patch({
      path: `cost_centers/${costCenterUuid}/archive`,
      options: { message: i18n.t('costCenters.notifications.archived') },
    })
  },
  unarchive: async costCenterUuid => {
    return await patch({
      path: `cost_centers/${costCenterUuid}/unarchive`,
      options: { message: i18n.t('costCenters.notifications.unarchived') },
    })
  },
}

export default costCentersApi
